import { ErrorCircleRegular } from '@fluentui/react-icons'
import { Button } from '@fluentui/react-components'
import styles from './ErrorState.module.css'

interface ErrorStateProps {
  title: string
  detail: string
  onRetry?: () => void
  retryLabel?: string
}

export function ErrorState({ title, detail, onRetry, retryLabel = 'Reîncearcă' }: ErrorStateProps) {
  return (
    <div className={styles.root} role="alert">
      <ErrorCircleRegular className={styles.icon} aria-hidden="true" />
      <div className={styles.copy}>
        <p className={styles.title}>{title}</p>
        <p className={styles.detail}>{detail}</p>
      </div>
      {onRetry ? (
        <Button appearance="secondary" size="small" onClick={onRetry}>
          {retryLabel}
        </Button>
      ) : null}
    </div>
  )
}
